import { css, keyframes } from "@emotion/react";
import { COLOR_CONSTANTS } from "src/domains/shared/constants/styles";
import { LAYER_HOVER_SURFACE } from "src/domains/shared/components/SideNav/PiledLayerManagement/shared/styles";

export const HOVER_SURFACE = LAYER_HOVER_SURFACE;
export const FIELD_BORDER = "rgba(0, 0, 0, 0.14)";
export const FIELD_HOVER_BORDER = "rgba(0, 0, 0, 0.3)";
export const FIELD_DISABLED_BG = "#f6f7f9";
export const SKELETON_BG = "#eceef1";
export const CAPTION = "rgba(0, 0, 0, 0.5)";
export const ERROR_SURFACE = "#fdecea";
export const INFO_SURFACE = "#f1f5ff";
export const NEUTRAL_SURFACE = "rgba(0, 0, 0, 0.05)";
export const SUBTLE_SURFACE = "#fafbfc";
export const FOCUS_RING = `0 0 0 3px ${COLOR_CONSTANTS.primary._states.focus}`;
export const MENU_SHADOW =
  "0 5px 5px -3px rgba(0,0,0,.2), 0 8px 10px 1px rgba(0,0,0,.14), 0 3px 14px 2px rgba(0,0,0,.12)";

export const ELLIPSIS = {
  overflow: "hidden",
  textOverflow: "ellipsis",
  whiteSpace: "nowrap",
  minWidth: 0,
} as const;

/**
 * 입력칸 아래에 겹쳐 띄우는 오류 상자 — 줄 높이를 늘리지 않는다.
 * 부모가 `position: relative` 여야 하고, 입력칸과 `aria-describedby` 로 잇는 것은 호출부 몫이다.
 */
export const FIELD_ERROR_POP_SX = {
  position: "absolute",
  top: "calc(100% + 4px)",
  left: 0,
  zIndex: 2,
  maxWidth: "100%",
  padding: "4px 8px",
  borderRadius: "6px",
  backgroundColor: COLOR_CONSTANTS.common.white_states.main,
  boxShadow: MENU_SHADOW,
  fontSize: 11,
  lineHeight: "16px",
  color: COLOR_CONSTANTS.error.main,
} as const;

/** 장비·시설 사이드바(`EquipmentPanel`·`EquipmentListSkeleton`·`EquipmentDetailReveal`·`EquipmentSmoothHeight`)와 같은 값. */
export const BRANCH_FADE_MS = 200;
export const SKELETON_SHOW_DELAY_MS = 150;
export const REVEAL_OPEN_MS = 220;
export const REVEAL_CLOSE_MS = 170;
export const HOVER_TRANSITION_MS = 180;
export const SWAP_FADE_MS = 180;

export const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`;

const revealOpen = keyframes`
  from { grid-template-rows: 0fr; opacity: 0; }
  to { grid-template-rows: 1fr; opacity: 1; }
`;

const revealClose = keyframes`
  from { grid-template-rows: 1fr; opacity: 1; }
  to { grid-template-rows: 0fr; opacity: 0; }
`;

export const swapFadeCss = css`
  animation: ${fadeIn} ${SWAP_FADE_MS}ms ease;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

const revealBase = css`
  display: grid;
  grid-template-rows: 1fr;
  & > * {
    min-height: 0;
    overflow: hidden;
  }
`;

export const revealOpenCss = css`
  ${revealBase};
  animation: ${revealOpen} ${REVEAL_OPEN_MS}ms ease-out;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const revealCloseCss = css`
  ${revealBase};
  animation: ${revealClose} ${REVEAL_CLOSE_MS}ms ease-in forwards;
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const revealIdleCss = revealBase;

export const REDUCED_MOTION_SX = {
  "@media (prefers-reduced-motion: reduce)": {
    transition: "none",
    animation: "none",
  },
} as const;
